import React from 'react';
import { DeliveryIcon, FlagIcon, CheckCircleGreenIcon, AddCartIcon } from 'ui-component/custom-icons/icons';



// ✅ Clear
const Breadcrumbs = ({ status, disabled }) => {

    
    return (
        <div className='card-breadcrumbs'>

            <nav>
                <ol className="cd-breadcrumb custom-separator" style={{ padding: '0', margin: '0', background: 'transparent' }}>
                
                    <li style={{ margin: '0' }}>
                        <a style={{ textDecoration: 'none' }}>
                            <div>

                                <button
                                    className={`btn btn-primary btn-outlined-main white-var`}
                                >
                                    <AddCartIcon width='18px' height='18px' />
                                    Pick Products
                                </button>
                                {
                                    status === 'Closed' && (
                                        <div style={{ position: 'absolute', top: '-6px' }}>
                                            <CheckCircleGreenIcon width={'15px'} height={'15px'} />
                                        </div>
                                    )
                                }
                            </div>
                        </a>
                    </li>
                    <li style={{ margin: '0' }}>
                        <a style={{ textDecoration: 'none' }}>
                            <div>
                                <button
                                    className={`btn btn-primary btn-outlined-main white-var`}
                                >
                                    <DeliveryIcon width='18px' height='18px' />
                                    Create Shipment
                                </button>
                                {
                                    status === 'Closed' && (
                                        <div style={{ position: 'absolute', top: '-6px' }}>
                                            <CheckCircleGreenIcon width={'15px'} height={'15px'} />
                                        </div>
                                    )
                                }
                            </div>
                        </a>
                    </li>
                    <li style={{ margin: '0' }}>
                        <a style={{ textDecoration: 'none' }}>
                            <div>
                                <button
                                    className={`btn btn-primary btn-outlined-main white-var`}
                                >
                                    <FlagIcon width='12px' height='12px' />
                                    Close Picklist
                                </button>
                                {
                                    status === 'Closed' && (
                                        <div style={{ position: 'absolute', top: '-6px' }}>
                                            <CheckCircleGreenIcon width={'15px'} height={'15px'} />
                                        </div>
                                    )
                                }
                            </div>
                        </a>
                    </li>
                </ol>
            </nav>
        </div>
    );
};

export default Breadcrumbs;
